import type { ReactNode } from 'react';

import { Portal } from 'atoms/layout/Portal';

type Props = { children: ReactNode };

export const SidebarToolbar = ({ children }: Props) => {
  return <Portal id="sidebar-layout-toolbar">{children}</Portal>;
};
